export const messages = {
  en: {
    reportCustomComponentFooterManage: {
      statistics: 'Statistics',
      id: 'ID',
      name: 'Name',
      queryMethod: 'Query Method',
      description: 'Description',
      fetchError: 'Failed to fetch footer list'
    }
  },
  zh: {
    reportCustomComponentFooterManage: {
      statistics: '统计',
      id: 'ID',
      name: '名称',
      queryMethod: '查询方式',
      description: '描述',
fetchError: '獲取頁腳列表失敗'
    }
  },
  'zh-TW': {
    reportCustomComponentFooterManage: {
      statistics: '統計',
      id: 'ID',
      name: '名稱',
      queryMethod: '查詢方式',
      description: '描述',
      fetchError: '獲取頁腳列表失敗'
    }
  }
}